import React from 'react';

import { OfferData } from '../types';

const HiringOfferContext = React.createContext<OfferData>(void 0);

export default HiringOfferContext;
